import React, { Component } from 'react';
import { connect } from "react-redux";
import { reduxForm, initialize } from 'redux-form';
import './shortcuts.css';

import { shortcutClicked } from '../../../redux/actions';
import { shortcuts } from '../../../redux/selectors';

import { getDomain } from '../../assets/util';

class Shortcuts extends Component {
  render() {
    const { user, shortcuts } = this.props;
    if(user && user.loggedIn) {
      return (
        <div className='big flex shortcuts'>
          {this.renderShortcuts(shortcuts)}
          {shortcuts.length < 5 ? this.renderAddShortcut() : null }
        </div>
      )
    } else {
      return null;
    }
  }
  renderShortcuts(shortcuts) {
      return shortcuts.map((shortcut, key) => {
        if (!shortcut.link.match(/^https?:\/\//i)) { shortcut.link = 'http://' + shortcut.link; }
        let favicon = getDomain(shortcut.link);

        return (
          <div key={key} className='shortcut' >
            <div className='mdi mdi-pencil hover' onClick={() => this.props.shortcutClicked(shortcut)} />
            <a href={shortcut.link} target="_blank">
              <div className='icon'><img src={`https://api.faviconkit.com/${favicon}/144`} href={shortcut.link} target="_blank" /></div>
              <p>{shortcut.title}</p>
            </a>
          </div>
        )
      })

  }
  renderAddShortcut() {
    return(
      <div className='shortcut' target="_blank" onClick={() => this.props.shortcutClicked(null)}>
        <div className='wrapper'>
          <div className='icon mdi mdi-plus'/>
          <p>Add shortcut</p>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.general.user,
    shortcuts: shortcuts(state),
  };
}

export default connect(mapStateToProps, { shortcutClicked })(Shortcuts);
